<template>
    <div class="container">
        <section class="section">
            <div class="row">
                <div class="col-md-4 mx-auto">
                    <form>
                        <div class="text-center">
                            <h1 class="mb-2">Reset your password</h1>
                            <p class="mb-5">
                                We make it easy for everyone to find exactly what they are looking for!
                            </p>
                        </div>
                    <br>
                    <div class="form-group">
                        <label class="form-label required">Password</label>
                        <input
                            class="form-control"
                            :class="{'has-error': errors.first('password') }"
                            ref="password"
                            type="password"
                            name="password"
                            v-validate="'required'"
                            data-vv-as="password"
                            v-model="resetPasswordData.password"
                        >
                        <div class="form-note">
                            Passwords must be at least 6 characters including 1 upper and 1 lower case.
                        </div>
                        <span class="form-error">{{ errors.first('password') }}</span>
                    </div>
                    <div class="form-group">
                        <label class="form-label required">Confirm password</label>
                        <input
                            class="form-control"
                            :class="{'has-error': errors.first('password_confirmation') }"
                            type="password"
                            name="password_confirmation"
                            v-model="resetPasswordData.password_confirmation"
                            v-validate="'required|confirmed:password'"
                            data-vv-as="password confirmation"
                            data-vv-delay="500"
                            @input="$validator.errors.remove('password')"
                        >
                        <span class="form-error">{{ errors.first('password_confirmation') }}</span>
                    </div>
                    <div class="form-group row align-items-center">
                        <div class="col-6">
                            <button
                                class="btn btn--primary"
                                :disabled="isLoading"
                                @click.prevent="changePassword"
                            >
                                Reset password
                            </button>
                        </div>
                    </div>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    inject: ['$validator'],
    data() {
        return {
            resetPasswordData: {},
            isLoading: false,
        };
    },
    created() {
        this.clearData();
    },
    methods: {
        changePassword() {
            this.isLoading = true;
            this.axios.put('/api/reset-password', this.resetPasswordData)
                .then(({ data }) => {
                    window.showSuccess('Success', data.message, () => {
                        window.location.href = '/';
                    });
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        clearData() {
            this.resetPasswordData = {
                password: '',
                password_confirmation: '',
                token: window.location.href.split('/').pop(), // Take the token at the end of the url
            };
            this.$validator.reset();
        },
    },
};
</script>
